import { LokiMarket } from './lokiProxy';
import { ConcernName, Recommendation, Sensitivity, SkinAnalyse, SkinType } from '../../type';
import { getProductsId } from '../mindstix/products';
import { fetchLokiVariants, getLokiRequestSkus, parseProductsFromLoki } from './lokiProducts';

export const getLokiRecommendations = async (
    analyses: SkinAnalyse[], skinType: SkinType, sensitivity: Sensitivity, dispatch: Function, market: LokiMarket = 'US',
): Promise<Recommendation[]> => {
    const requests = await Promise.all(analyses.map(async (analyse) => ({
        concern: analyse.name as ConcernName,
        ...await getProductsId(market, analyse.name as ConcernName, analyse.score, skinType, sensitivity, dispatch),
    })));
    const allProducts = requests.flatMap((request) => [
        ...request.mainProducts, ...request.otherProducts, ...request.uvProducts,
    ]);
    const variants = await fetchLokiVariants({ variantIds: getLokiRequestSkus(allProducts) }, market);

    // Parse each group separately to retain its category, priority and mutable tags.
    return requests.map((request) => ({
        concern: request.concern,
        mainProducts: parseProductsFromLoki(variants, request.mainProducts),
        otherProducts: parseProductsFromLoki(variants, request.otherProducts),
        uvProducts: parseProductsFromLoki(variants, request.uvProducts),
    }));
};
